module.exports = __webpack_public_path__ + "img/feature_buy_zh.a50b8495.png";